import { Component, OnInit } from '@angular/core';

@Component({selector: 'app-loading-small',
  templateUrl: './loading-small.component.html',
  styleUrls: ['./loading-small.component.scss'], standalone: false})
export class LoadingSmallComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
